import { globalEmitter, emitterProps } from '@/components/helpers/emitter-event'
import { swymService } from 'libs/swym/swym-service'

/**
 * Renders the wishlist item-count badge inside the header link.
 * Hidden at zero. Hydrated by swym-init's initial getList().
 */
export class WishlistCount extends HTMLElement {
  private handler = (e: CustomEvent<{ count: number }>) => this.render(e.detail.count)

  connectedCallback(): void {
    globalEmitter.on(emitterProps.wishlist.change, this.handler)
    this.render(swymService.count())
  }

  disconnectedCallback(): void {
    globalEmitter.off(emitterProps.wishlist.change, this.handler)
  }

  private render(count: number): void {
    if (count > 0) {
      this.textContent = String(count > 9 ? '9+' : count)
      this.removeAttribute('hidden')
    } else {
      this.textContent = ''
      this.setAttribute('hidden', '')
    }
  }
}
